<template>
<div class="bk-gray-dark  trick-2">
  <img src="../../../assets/images/preparare-formule/truc2.png" alt="/">

  <p>2. Temperatura apei cu care prepari laptele contează</p>
    <span>Este important ca în momentul preparării, apa să fie răcită la cca. 37 °C. Dacă folosești apă plată, ea
        tot trebuie încălzită până ajunge la această temperatură.</span>
</div>
</template>

<script>
export default {
    name: 'Temperatura',

    data() {
        return {

        }
    },
}
</script>
<style lang="scss" scoped>
.trick-2 p{
  margin-top: 50px;
  color: #17479E;
  font-size: 20px;
  font-weight: 600;
}

.trick-2 span{
  font-size: 16px;
  color: #17479e;
}

.trick-2 img {
  position: absolute;
  left: 20px;
  top: -60px;
}
.bk-blue-light {
    background: #F1F8FF;
    border-radius: 20px;
    padding-top: 65px;
    width: 420px !important;
    min-height: 380px;
    max-height: 380px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        max-height: 100%;
        min-height: auto;
        padding-top: 45px;
    }

    p {
        font-size: 16px;
        font-weight: 600;
        color: #029FE3;
    }

    span {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }
}

.trick-2 img {
    position: absolute;
    left: 20px;
    top: -60px;
}

@media screen and (max-width: 526px){
  .trick-2 img{
    width: 89px;
    height: 89px;
    top: -40px;
  }
}
</style>
